'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getReactions;

var _ramda = require('ramda');

var _inheritance = require('../model/model_concerns/inheritance');

function getReactions(model) {
  var recvMethodNames = (0, _ramda.filter)((0, _ramda.startsWith)('recv'), (0, _ramda.keys)((0, _inheritance.getAllFunctions)(model)));

  return (0, _ramda.map)(function (recvMethod) {
    return model[recvMethod]();
  }, recvMethodNames);
}